<template>
<!-- 基本信息 -->
  <el-descriptions :title="$t('pages.system.text75')">
    <el-descriptions-item :label="$t('pages.system.text109')">{{info.departmentName}}</el-descriptions-item>
    <el-descriptions-item :label="$t('pages.system.text110')">{{info.departmentDesc}}</el-descriptions-item>
  </el-descriptions>
</template>


<script>
export default {
  data(){
    return{}
  },
  props:['info']
}
</script>